import React, { useEffect, useState } from "react";
import { Button, Col, Container, Figure, Form, Row } from "react-bootstrap";
import {
  bioDataPayload,
  setValueKey,
  setValueKeyObject,
} from "../../../helper/helper";
import { constantTypes } from "../../../utils/constants/constant";
import { useFieldArray, useForm } from "react-hook-form";
import { Loader } from "lucide-react";
import MainInformation from "./Add/mainInformation";
import ResidenceInfo from "../../../components/RegistrationFormComponents.js/ResidenceInfo";
import VillageAddress from "../../../components/RegistrationFormComponents.js/VillageAddress";
import EducationInformation from "./Add/EducationInformation";
import ProfessionalDetails from "./Add/ProfessionalDetails";
import FamilyInformation from "./Add/FamilyInformation";
import ContactPersoneInformation from "./Add/ContactPersone";
import UploadMultiImages from "./Add/UploadMultiImages";
import moment from "moment";
import useToastContext from "../../../hooks/useToastContext";
import {
  addBioDataApi,
  editBioDataApi,
  getMaritalByIdApi,
} from "../../../hooks/ApisContainer/Matrimonial";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL } from "../../../services/path";

const AddEditMetrimonial = () => {
  const notification = useToastContext();
  const navigate = useNavigate();
  const { id } = useParams();

  // HOOK FORM
  const {
    control,
    register,
    setValue,
    clearErrors,
    watch,
    setError,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      familyInformation: [constantTypes.familyInformation],
    },
  });

  const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

  // ALL STATE
  const [phone, setPhone] = useState("");
  const [dobDate, setDobDate] = useState("");
  const [dateError, setDateError] = useState("");
  const [officePhone, setOfficePhone] = useState("");
  const { fields, append, remove } = useFieldArray({
    control,
    name: "familyInformation",
  });
  const [familyMemberDOBError, setFamilyMemberDOBError] = useState([]);
  const [familyMemberDOB, setFamilyMemberDOB] = useState([]);
  const [FamilyPhone, setFamilyPhone] = useState([]);
  const [profilePic, setProfilePic] = useState(
    "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRzJtv72esjEWvfSpkux9LhOEGiBQ5vuR8drQ&s"
  );
  const [profileFile, setProfileFile] = useState(null);
  const [ContactPersonPhone, setContactPersonPhone] = useState("");
  const [multipleImages, setMultipleImages] = useState([]);
  const [deleteMultipleImages, setDeleteMultipleImages] = useState([]);
  const [maritalDetail, setMaritalDetail] = useState({});
  const [loader, setLoader] = useState(false);
  const [selectedValue, setSelectedValue] = useState("working");

  const fetchedGetMaritalById = () => {
    getMaritalByIdApi({ id }, notification, (loading, error, response) => {
      if (!error) {
        setMaritalDetail(response);
        setDobDate(response?.birthDetails?.dob);
        setOfficePhone(
          "91" + response["professionalDetails"]["officePhoneNumber"]
        );
        setContactPersonPhone(
          "91" + response["contactPersonInformation"]["mobileNumber"]
        );
        setProfilePic(BASE_URL + "/uploads/" + response?.image);
        setValue(
          "multipleImage",
          response.multipleImage?.map((item) => BASE_URL + "/uploads/" + item)
        );
        [
          "firstName",
          "lastName",
          "rashi",
          "religion",
          "gotra",
          "height",
          "weight",
          "personality",
          "familyInformation",
          "gender",
          "diet",
        ].forEach((key) => {
          setValue(key, response[key]);
        });
        ["timeOfBirth", "day", "placeOfBirth"].forEach((key) => {
          setValue(key, response["birthDetails"][key]);
        });
        ["degree", "collegeName", "yearOfPassing"].forEach((key) => {
          setValue(key, response?.["education"]?.[key] || "");
        });
        [
          { key: "officeDesignationName", value: "designation" },
          { key: "annualIncome", value: "annualIncome" },
        ].forEach(({ key, value }) => {
          setValue(key, response["officeInformation"][value]);
        });
        [
          { key: "contactPersonName", value: "name" },
          { key: "contactPersonMobile", value: "mobileNumber" },
          { key: "contactPersonEmail", value: "email" },
        ].forEach(({ key, value }) => {
          setValue(key, response["contactPersonInformation"][value]);
        });
        [
          { key: "officeName", value: "officeName" },
          { key: "officeDepartmentName", value: "departmentName" },
          { key: "officeDesignation", value: "officeDesignationName" },
          { key: "officeAddress", value: "officeAddress" },
          { key: "officePhoneNumber", value: "officePhoneNumber" },
          { key: "officeNumber", value: "tel" },
          { key: "description", value: "description" },
          { key: "maritalStatus", value: "maritalStatus" },
        ].forEach(({ key, value }) => {
          setValue(key, response["professionalDetails"][value]);
        });

        [
          { key: "CurrentAddressLineOne", value: "line1" },
          { key: "CurrentAddressLineTwo", value: "line2" },
          { key: "currentDistrict", value: "district" },
          { key: "currentCity", value: "city" },
          { key: "currentState", value: "state" },
          { key: "currentCountry", value: "country" },
          { key: "currentLandMark", value: "landmark" },
          { key: "currentPinCode", value: "pinCode" },
        ].forEach(({ key, value }) => {
          setValue(key, response["address"][value]);
        });

        [
          { key: "villageAddressLineOne", value: "line1" },
          { key: "villageAddressLineTwo", value: "line2" },
          { key: "villageDistrict", value: "district" },
          { key: "villageCity", value: "city" },
          { key: "villageState", value: "state" },
          { key: "villageCountry", value: "country" },
          { key: "villageLandMark", value: "landmark" },
          { key: "villagePinCode", value: "pinCode" },
        ].forEach(({ key, value }) => {
          setValue(key, response["villageAddress"][value]);
        });
      }
    });
  };

  const onSubmit = (data) => {
    const isValid = dateValidation(dobDate, familyMemberDOB);
    const dateOfBirth = moment(dobDate).format("YYYY-MM-DD");

    const familyData = data?.familyInformation.map((el, index) => {
      return {
        ...el,
      };
    });

    data.familyInformation = familyData;

    const formData = bioDataPayload(
      data,
      dateOfBirth,
      profileFile,
      multipleImages,
      deleteMultipleImages
    );

    if (isValid) {
      Object.keys(maritalDetail).length > 0
        ? editBioDataApi(id, formData, notification, (loading, error) => {
            setLoader(loading);
            if (!error) {
              navigate("/matrimonial-post");
            }
          })
        : addBioDataApi(formData, notification, (loading, error) => {
            setLoader(loading);
            if (!error) {
              navigate("/matrimonial-post");
            }
          });
    }
  };

  const dateValidation = (date) => {
    let dateError = "";

    if (!date) {
      dateError = "Date field is required.";
    } else {
      dateError = "";
    }

    if (dateError) {
      setDateError(dateError);
      return false;
    } else {
      setDateError(dateError);
      return true;
    }
  };

  const handleChangeDate = (dates, index) => {
    setDobDate(...dates);
    dateValidation(...dates, dobDate);
  };

  const handleChangeFamilyMemberDate = (dates, index) => {
    // const newFamilyMemberDOB = [...familyMemberDOB];
    // newFamilyMemberDOB[index] = dates[0];
    // setFamilyMemberDOB(newFamilyMemberDOB);
    dateValidation(...dates, index);
  };

  const handleRemoveImage = (item, index) => {
    if (typeof item === "object") {
      setMultipleImages(multipleImages.filter((el, i) => i !== index));
    } else {
      setMultipleImages(multipleImages.filter((el, i) => i !== index));
      setDeleteMultipleImages([
        ...multipleImages.filter((el, i) => i === index),
        ...deleteMultipleImages,
      ]);
    }
  };

  useEffect(() => {
    if (
      [...Array.from(watch("multipleImage") || [])].every((item) =>
        typeof item === "object" ? allowedTypes.includes(item.type) : true
      )
    )
      setMultipleImages([
        ...multipleImages,
        ...Array.from(watch("multipleImage") || []),
      ]);
  }, [watch("multipleImage")]);

  useEffect(() => {
    if (id?.length === 24) {
      fetchedGetMaritalById();
    }
  }, [id]);

  return (
    <div>
      <section className="registration-form-sec" style={{ padding: "0px 0px" }}>
        <Container>
          <Form
            className="p-md-4 p-sm-2 px-0 text-start"
            onSubmit={handleSubmit(onSubmit)}
            noValidate
            autoComplete="off"
          >
            <div className="login-sec d-block pt-0 mb-2">
              <div class="common-heading text-center mb-5">
                <h2>
                  {Object.keys(maritalDetail).length > 0
                    ? "Edit"
                    : "Create New"}{" "}
                  Bio-Data
                </h2>
              </div>

              <MainInformation
                register={register}
                errors={errors}
                setPhone={setPhone}
                phone={phone}
                setValue={setValue}
                dobDate={dobDate}
                handleChangeDate={handleChangeDate}
                dateError={dateError}
                setProfilePic={setProfilePic}
                profilePic={profilePic}
                setProfileFile={setProfileFile}
                profileFile={profileFile}
              />

              <ResidenceInfo register={register} errors={errors} />
              <VillageAddress register={register} errors={errors} />
              <EducationInformation register={register} errors={errors} />
              <ProfessionalDetails
                register={register}
                errors={errors}
                setValue={setValue}
                setOfficePhone={setOfficePhone}
                officePhone={officePhone}
                setSelectedValue={setSelectedValue}
                selectedValue={selectedValue}
              />
              <FamilyInformation
                register={register}
                errors={errors}
                setValue={setValue}
                familyMemberDOBError={familyMemberDOBError}
                handleChangeFamilyMemberDate={handleChangeFamilyMemberDate}
                familyMemberDOB={familyMemberDOB}
                setFamilyPhone={setFamilyPhone}
                FamilyPhone={FamilyPhone}
                fields={fields}
                append={append}
                remove={remove}
              />

              <ContactPersoneInformation
                register={register}
                errors={errors}
                setValue={setValue}
                setContactPersonPhone={setContactPersonPhone}
                ContactPersonPhone={ContactPersonPhone}
              />
              <UploadMultiImages
                register={register}
                errors={errors}
                multipleImages={multipleImages}
                eventDetail={maritalDetail}
                handleRemoveImage={handleRemoveImage}
                allowedTypes={allowedTypes}
              />

              <Button
                type="submit"
                className="themeht-btn btn w-100 py-2 mt-3"
                onClick={() => dateValidation(dobDate)}
                disabled={loader}
                style={
                  loader
                    ? { cursor: "not-allowed", background: "lightGray" }
                    : { cursor: "pointer" }
                }
              >
                <span className="d-flex fs-6 justify-content-center align-items-center">
                  {Object.keys(maritalDetail).length > 0 ? "Update" : "Submit"}{" "}
                  {loader && (
                    <Loader
                      style={{
                        marginLeft: "20px",
                      }}
                      className="loader"
                    />
                  )}
                </span>
              </Button>
            </div>
          </Form>
        </Container>
      </section>
    </div>
  );
};

export default AddEditMetrimonial;
